import { useEffect, useState } from "react";
import { useRouter } from "@tanstack/react-router";

/**
 * NProgress-style 2px bronze bar that animates at the top of the viewport
 * while a route transition is in flight.
 */
export function PageLoadingBar() {
  const router = useRouter();
  const [active, setActive] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let raf: number | undefined;
    const offBefore = router.subscribe("onBeforeLoad", () => {
      setActive(true);
      setProgress(15);
      const tick = () => {
        setProgress((p) => (p < 85 ? p + (90 - p) * 0.05 : p));
        raf = requestAnimationFrame(tick);
      };
      raf = requestAnimationFrame(tick);
    });
    const finish = () => {
      if (raf) cancelAnimationFrame(raf);
      setProgress(100);
      setTimeout(() => {
        setActive(false);
        setProgress(0);
      }, 250);
    };
    const offResolved = router.subscribe("onResolved", finish);
    return () => {
      offBefore();
      offResolved();
      if (raf) cancelAnimationFrame(raf);
    };
  }, [router]);

  return (
    <div
      aria-hidden
      className="pointer-events-none fixed inset-x-0 top-0 z-[100] h-[2px] bg-transparent"
    >
      <div
        className="h-full bg-bronze-600 transition-[width,opacity] duration-200 ease-out"
        style={{
          width: `${progress}%`,
          opacity: active ? 1 : 0,
          boxShadow: "0 0 8px rgba(168,139,92,0.6)",
        }}
      />
    </div>
  );
}